import React from 'react';
import MemberBadge from './member-badge';
import { useIsMember } from './member-store';

interface Props {
  creatorId?: string;
  userId?: string | null;
  size?: number;
  className?: string;
}

/** Huy hiệu hội viên cạnh tên một người, tự tra theo (kênh, người). Không có id (ví dụ ẩn danh) thì không hiện. */
const MemberMark: React.FC<Props> = ({ creatorId, userId, size = 14, className }) => {
  const isMember = useIsMember(creatorId, userId ?? undefined);
  return isMember ? (
    <MemberBadge size={size} className={className ?? 'inline-block ml-1 align-text-bottom'} />
  ) : null;
};

export default MemberMark;
